/**
 * Digital Ocean serverless functions base URL.
 * Used for dashboard, billing, pods, users, and related endpoints.
 */

export const WARM_DASHBOARD_API_BASE = "https://server3.kynzo.io/v1/web/v1";

/**
 * Digital Ocean serverless function base URL for AI comment generation.
 * Same backend the Chrome extension uses to generate LinkedIn comments.
 */
export const GENERATE_COMMENT_API_BASE = "https://kynzo-generate-comment-api-c9axg.ondigitalocean.app/v1/web/v1";